import { render, staticRenderFns } from "./TaskEditorToolbarItem.vue?vue&type=template&id=8e95cd02&scoped=true&"
import script from "./TaskEditorToolbarItem.vue?vue&type=script&lang=js&"
export * from "./TaskEditorToolbarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e95cd02",
  null
  
)

export default component.exports